import React from 'react'
import { ExtendCurrency } from 'src/enums'
import { useCurrencyFormatter } from 'src/localization/Crncy'
import { useTranslate } from 'src/localization/Trns'
import { ManagerApprovalRulesResponse } from 'src/models/organizations.models'
import { toDollars } from 'src/utils/currency.utils'

interface ManagerReviewSettingsContentProps {
  rules?: ManagerApprovalRulesResponse
}

const ManagerReviewSettingsContent: React.FC<
  ManagerReviewSettingsContentProps
> = (props): React.ReactElement => {
  const translate = useTranslate()
  const currencyFormatter = useCurrencyFormatter()
  const { rules } = props

  const isManagerApprovalsOn = rules?.managerReviewEnabled

  return (
    <div className={'flex-column gap-6'}>
      <div className={'flex-column gap-2'}>
        <span className={'font-form-label'}>
          {translate('Manager Approver Rule')}
        </span>
        <span className={'font-regular text-primary'}>
          {translate(isManagerApprovalsOn ? 'ON' : 'OFF')}
        </span>
      </div>
      {isManagerApprovalsOn &&
        (rules?.managerReviewUsdThresholdCents !== undefined ||
          rules?.managerReviewCadThresholdCents !== undefined) && (
          <div className={'flex-column gap-2'}>
            <span className={'font-form-label'}>
              {translate('Minimum Manager Approver Threshold')}
            </span>
            {rules?.managerReviewUsdThresholdCents !== undefined && (
              <span
                className={
                  'flex-row align-center gap-1 font-regular text-primary'
                }
              >
                {currencyFormatter({
                  amount: toDollars(rules.managerReviewUsdThresholdCents),
                  currency: ExtendCurrency.Usd,
                  forceHideCurrency: true,
                })}
                <span className={'font-regular text-secondary'}>
                  {ExtendCurrency.Usd}
                </span>
              </span>
            )}
            {rules?.managerReviewCadThresholdCents !== undefined && (
              <span
                className={
                  'flex-row align-center gap-1 font-regular text-primary'
                }
              >
                {currencyFormatter({
                  amount: toDollars(rules.managerReviewCadThresholdCents),
                  currency: ExtendCurrency.Cad,
                  forceHideCurrency: true,
                })}
                <span className={'font-regular text-secondary'}>
                  {ExtendCurrency.Cad}
                </span>
              </span>
            )}
          </div>
        )}
    </div>
  )
}

export default ManagerReviewSettingsContent
